export const webEndPoint = "https://senthanamuthankidswear.shop/dev_api/api/";
// export const webEndPoint = "https://senthanamuthankidswear.shop/prod_api/api/";